import { useContext } from "react";

import { FlocknoteAppState } from "Flocknote/state.js";
import flocknoteStateHooks from "Flocknote/stateHooks";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";

import { ButtonIcon } from "UI/FnrButton3";
import FnrPreviewBar, { ActionButton, ActionButtons } from "UI/FnrPreviewBar";

export default function AdminPanelFooter() {
  const { shouldHideNonNetworkEnabledSettings } =
    useFamilyRegistrationAdminPermissions();
  const isClosedNetwork = flocknoteStateHooks.useIsClosedNetwork();

  const fnDispatch = useContext(FlocknoteAppState)[1];

  const {
    state: {
      selectedPanel,
      familyRegistrationSettings: {
        recurringGifts: { enabled: fundItEnabled, selectedFundID },
        receiveGivingEnvelopes: { enabled: givingEnvelopesEnabled },
      },
    },
  } = useFamilyRegistrationContext();

  const addSmartButtonToEmail = () => {
    localStorage.setItem(
      "familyRegToEmailNote",
      JSON.stringify({ timestamp: Date.now() })
    );
    window.fnReactBus.openEmailComposer();
    fnDispatch({ type: "Composer Maximized" });
  };

  const url = `${window.location.origin}/register`;

  let previewURL = url;

  if (selectedPanel === "member-info") previewURL += "/additional-info";
  else if (selectedPanel === "children-info")
    previewURL += "/children?member=new";
  else if (selectedPanel === "giving" && fundItEnabled && selectedFundID)
    previewURL += "/recurring";
  else if (selectedPanel === "giving" && givingEnvelopesEnabled)
    previewURL += "/envelopes";

  return (
    <FnrPreviewBar
      shouldHideAnimation={
        shouldHideNonNetworkEnabledSettings || isClosedNetwork
      }
      title="Your registration URL"
      url={url}
      previewUrl={previewURL}
      isPublic
      showActionButtons
      renderActionButtons={() => (
        <ActionButtons>
          <ActionButton
            clickHandler={addSmartButtonToEmail}
            text="Add to Email"
            icon={<ButtonIcon fas fa-envelope />}
            color="blue"
          />
        </ActionButtons>
      )}
    />
  );
}
